import {
  ACCENT_COLOR_TYPE_BY_BONUS,
  acceptModeType,
  BONUS_DETAILS_KEYS,
  BONUSES_TYPES_FOR_IMAGES,
  fundsBonusAmountType,
  fundsBonusSystemStates,
  fundsStates,
  progressBarStates,
  PWS_BONUS_TYPE
} from '../../../constants';
import getOutputBetType from '../../../utils/getOutputBetType';
import prepareBonusDetailsList from '../../../utils/prepareBonusDetailsList';

const PWS_STATUSES_TO_DISPLAY_AMOUNT = [
  fundsBonusSystemStates.WAGERING,
  fundsBonusSystemStates.COMPLETED
];

const getTimerTitle = ({ state, isCashback, outputMaxTotal, t }) => {
  if (state === fundsStates.BONUS_POTENCIAL) {
    return t('web.personaloffice.bonuses.timer.time.to.deposit');
  }

  if (state === fundsStates.BONUS_PROPOSED && isCashback) {
    return t('web.personaloffice.bonuses.timer.time.to.start');
  }

  if (
    outputMaxTotal > 0 &&
    [fundsStates.BONUS_WAGERING, fundsStates.BONUS_PROPOSED].includes(state)
  ) {
    return t('web.personaloffice.bonuses.timer.hurry.up.to.wager');
  }

  if (state === fundsStates.BONUS_WAGERING && isCashback) {
    return t('web.personaloffice.bonuses.cbb.timer.wagering');
  }

  if (state === fundsStates.BONUS_WAGERING) {
    return t('bonuses.countdownTimer.timeForActivity');
  }

  if (state === fundsStates.BONUS_ACTVATED && isCashback) {
    return t('web.personaloffice.bonuses.timer.time.to.accepts');
  }

  if (state === fundsBonusSystemStates.WAGERING) {
    return t('web.personaloffice.bonuses.timer.hurry.up.to.wager');
  }

  if (
    state === fundsBonusSystemStates.PROPOSED ||
    state === fundsBonusSystemStates.POTENTIAL ||
    state === fundsBonusSystemStates.SPINNING
  ) {
    return t('web.personalOffice.bonuses.timeToActivate');
  }

  return '';
};

const getProgressBarStatus = ({ state, outputBetTotal }) => {
  if (
    state === fundsStates.BONUS_WAGERING ||
    state === fundsBonusSystemStates.WAGERING
  ) {
    return progressBarStates.ACTIVE;
  }
  if (outputBetTotal === 0 && state === fundsStates.BONUS_PROPOSED) {
    return progressBarStates.NOT_ACTIVE;
  }
  if (
    outputBetTotal > 0 &&
    [fundsStates.BONUS_PROPOSED, fundsBonusSystemStates.COMPLETED].includes(
      state
    )
  ) {
    return progressBarStates.DISABLED;
  }
  if (
    [
      fundsStates.BONUS_INCOME_NOT_ACHIEVED,
      fundsStates.BONUS_OUTPUT_NOT_ACHIEVED,
      fundsStates.BONUS_WASNOT_ACTIVATED
    ].includes(state)
  ) {
    return progressBarStates.EXPIRED;
  }
  if (
    [
      fundsBonusSystemStates.CANCELED_BY_MANAGER,
      fundsBonusSystemStates.CANCELED_BY_PLAYER,
      fundsBonusSystemStates.EXPIRED_PROPOSED,
      fundsBonusSystemStates.EXPIRED_WAGERING_PERIOD
    ].includes(state)
  ) {
    return progressBarStates.COMPLETED;
  }

  return '';
};

const getBonusDetailsList = ({
  bonusData,
  t,
  f,
  isShowServices,
  isShowMaxBonus,
  isShowBonusAmountText
}) => {
  const {
    bonusSum,
    currency,
    isCashback,
    state,
    outputMaxTotal,
    incomeDepositMin,
    wagerMultiplier,
    limitCalcPercent,
    bonusMaxSum,
    bonusMinSum,
    services,
    outputBetType,
    maxActivationTime = {},
    updatedAt,
    triggerSettings,
    gameName,
    bonusType
  } = bonusData;

  const {
    bonusAmountType,
    currency: triggerCurrency,
    percentOfDeposit
  } = triggerSettings || {};
  const { minDeposit, maxDeposit } = triggerCurrency || {};

  const DATE_FORMATS_TYPES = f.getFormats();

  return prepareBonusDetailsList([
    {
      key: BONUS_DETAILS_KEYS.BONUS_AMOUNT,
      name: t('web.personaloffice.bonuses.bonus.amount'),
      // delete after normalize refactor <Amount />
      value: `${bonusSum}${currency ? ` ${currency}` : ''}`,
      amount: bonusSum,
      currency: currency || '',
      isDisplay:
        bonusType === PWS_BONUS_TYPE
          ? bonusType === PWS_BONUS_TYPE &&
            bonusSum !== null &&
            PWS_STATUSES_TO_DISPLAY_AMOUNT.includes(state)
          : bonusSum &&
            bonusSum !== null &&
            !isCashback &&
            state !== fundsBonusSystemStates.POTENTIAL &&
            state !== fundsBonusSystemStates.EXPIRED_POTENTIAL,
      isBonusAmount: true
    },
    {
      key: BONUS_DETAILS_KEYS.BONUS_AMOUNT,
      name: t('web.personaloffice.bonuses.bonus.amount'),
      value: isShowBonusAmountText
        ? t('web.personaloffice.bonuses.bonus.amount.percent', [
            percentOfDeposit
          ])
        : `${percentOfDeposit}%`,
      isDisplay:
        state === fundsBonusSystemStates.POTENTIAL &&
        bonusAmountType === fundsBonusAmountType.PERCENT
    },
    {
      key: BONUS_DETAILS_KEYS.BONUS_AMOUNT,
      name: t('web.personaloffice.bonuses.bonus.amount'),
      // delete after normalize refactor <Amount />
      value: `${bonusSum}${currency ? ` ${currency}` : ''}`,
      amount: bonusSum,
      currency: currency || '',
      isDisplay:
        bonusSum !== null && state === fundsBonusSystemStates.POTENTIAL,
      isBonusAmount: true
    },
    {
      key: BONUS_DETAILS_KEYS.MIN_DEPOSIT,
      name: t('web.personaloffice.bonuses.potential.min.deposit'),
      // delete after normalize refactor <Amount />
      value: `${minDeposit} ${currency}`,
      amount: minDeposit,
      currency,
      isDisplay: state === fundsBonusSystemStates.POTENTIAL,
      isBonusAmount: true
    },
    {
      name: t('web.personaloffice.bonuses.potential.max.deposit'),
      // delete after normalize refactor <Amount />
      value: `${maxDeposit} ${currency}`,
      amount: maxDeposit,
      currency,
      isDisplay:
        bonusType !== PWS_BONUS_TYPE &&
        maxDeposit &&
        state === fundsBonusSystemStates.POTENTIAL &&
        !isShowMaxBonus,
      isBonusAmount: true
    },
    {
      key: BONUS_DETAILS_KEYS.MAX_BONUS,
      name: t('web.personaloffice.bonuses.potential.max.bonus'),
      // delete after normalize refactor <Amount />
      value: `${(maxDeposit * percentOfDeposit) / 100} ${currency}`,
      amount: (maxDeposit * percentOfDeposit) / 100,
      currency,
      isDisplay:
        bonusType !== PWS_BONUS_TYPE &&
        state === fundsBonusSystemStates.POTENTIAL &&
        maxDeposit &&
        percentOfDeposit &&
        isShowMaxBonus,
      isBonusAmount: true
    },
    {
      name: t('web.personaloffice.bonuses.game'),
      value: gameName,
      isDisplay:
        bonusType === PWS_BONUS_TYPE &&
        ![
          fundsBonusSystemStates.COMPLETED,
          fundsBonusSystemStates.WAGERING
        ].includes(state)
    },
    {
      key: BONUS_DETAILS_KEYS.WAGER_AMOUNT,
      name: t('web.personalOffice.bonuses.wagerAmount'),
      value: `x${wagerMultiplier}`,
      isDisplay: wagerMultiplier > 0
    },
    {
      name: t('web.personaloffice.bonuses.required.wager'),
      // delete after normalize refactor <Amount />
      value: `${outputMaxTotal}${currency ? ` ${currency}` : ''}`,
      amount: outputMaxTotal,
      currency: currency || '',
      isDisplay:
        bonusType === PWS_BONUS_TYPE
          ? [
              fundsBonusSystemStates.WAGERING,
              fundsBonusSystemStates.COMPLETED
            ].includes(state)
          : outputMaxTotal > 0 &&
            state !== fundsBonusSystemStates.POTENTIAL &&
            state !== fundsBonusSystemStates.EXPIRED_POTENTIAL,
      isBonusAmount: true
    },
    {
      name: t('web.personaloffice.bonuses.min.deposit.activate'),
      // delete after normalize refactor <Amount />
      value: `${incomeDepositMin}${currency ? ` ${currency}` : ''}`,
      amount: incomeDepositMin,
      currency: currency || '',
      isDisplay:
        isCashback &&
        (state === fundsStates.BONUS_POTENCIAL ||
          state === fundsStates.BONUS_INCOME_NOT_ACHIEVED ||
          state === fundsStates.BONUS_OUTPUT_NOT_ACHIEVED ||
          state === fundsStates.BONUS_WASNOT_ACTIVATED ||
          state === fundsBonusSystemStates.POTENTIAL),
      isBonusAmount: true
    },
    {
      name: t('web.personaloffice.bonuses.cashback.interest'),
      value: `${limitCalcPercent}%`,
      isDisplay:
        isCashback &&
        state !== fundsStates.BONUS_ACTVATED &&
        state !== fundsStates.BONUS_RELEASED
    },
    {
      name: t('web.personaloffice.bonuses.cbb.available.cashback'),
      // delete after normalize refactor <Amount />
      value: `${bonusSum} ${currency}`,
      amount: bonusSum,
      currency,
      isDisplay: isCashback && state === fundsStates.BONUS_ACTVATED,
      isBonusAmount: true
    },
    {
      name: t('web.personaloffice.bonuses.cashback.amount'),
      // delete after normalize refactor <Amount />
      value: `${bonusSum} ${currency}`,
      amount: bonusSum,
      currency,
      isDisplay: isCashback && state === fundsStates.BONUS_RELEASED,
      isBonusAmount: true
    },
    {
      name: t('web.personaloffice.bonuses.min.cashback.amount'),
      // delete after normalize refactor <Amount />
      value: `${bonusMinSum}${currency ? ` ${currency}` : ''}`,
      amount: bonusMinSum,
      currency: currency || '',
      isDisplay:
        isCashback &&
        state !== fundsStates.BONUS_ACTVATED &&
        state !== fundsStates.BONUS_RELEASED,
      isBonusAmount: true
    },
    {
      name: t('web.personaloffice.bonuses.max.cashback.amount'),
      // delete after normalize refactor <Amount />
      value: `${bonusMaxSum}${currency ? ` ${currency}` : ''}`,
      amount: bonusMaxSum,
      currency: currency || '',
      isDisplay:
        isCashback &&
        state !== fundsStates.BONUS_ACTVATED &&
        state !== fundsStates.BONUS_RELEASED,
      isBonusAmount: true
    },
    {
      key: BONUS_DETAILS_KEYS.SERVICES,
      name: t('web.personaloffice.bonuses.servises'),
      value: t(
        `web.personaloffice.bonuses.bet.type.${getOutputBetType(outputBetType)}`
      ),
      isDisplay:
        isCashback &&
        isShowServices &&
        state !== fundsStates.BONUS_ACTVATED &&
        state !== fundsStates.BONUS_RELEASED
    },
    {
      name: t('web.personaloffice.bonuses.servises'),
      value: services,
      isDisplay: isShowServices && services && bonusType !== PWS_BONUS_TYPE
    },
    {
      key: BONUS_DETAILS_KEYS.DATE,
      name: t('web.personaloffice.bonuses.expired.date'),
      value: f
        .getDateTime({ date: maxActivationTime?.sec * 1000 })
        ?.toFormat(DATE_FORMATS_TYPES.BONUSES_DATE_FORMAT),
      isDisplay:
        state === fundsStates.BONUS_INCOME_NOT_ACHIEVED ||
        state === fundsStates.BONUS_OUTPUT_NOT_ACHIEVED ||
        state === fundsStates.BONUS_WASNOT_ACTIVATED
    },
    {
      key: BONUS_DETAILS_KEYS.DATE,
      name: t('web.personaloffice.bonuses.expiry.date'),
      value: f
        .getDateTime({ date: maxActivationTime?.sec * 1000 })
        ?.toFormat(DATE_FORMATS_TYPES.BONUSES_DATE_FORMAT),
      isDisplay: !isCashback && state === fundsStates.BONUS_ACTVATED
    },
    {
      key: BONUS_DETAILS_KEYS.DATE,
      name: t('web.personaloffice.bonuses.complited'),
      value: f
        .getDateTime({ date: maxActivationTime?.sec * 1000 })
        ?.toFormat(DATE_FORMATS_TYPES.BONUSES_DATE_FORMAT),
      isDisplay: state === fundsStates.BONUS_RELEASED
    },
    {
      key: BONUS_DETAILS_KEYS.DATE,
      name: t('web.personalOffice.bonuses.expiredDate'),
      value: f
        .getDateTime({
          date: updatedAt,
          fromUTC: true,
          format: 'dd.MM.yyyy HH:mm:ss'
        })
        ?.toFormat(DATE_FORMATS_TYPES.BONUSES_DATE_FORMAT),
      isDisplay: [
        fundsBonusSystemStates.EXPIRED_POTENTIAL,
        fundsBonusSystemStates.EXPIRED_PROPOSED,
        fundsBonusSystemStates.EXPIRED_WAGERING_PERIOD,
        fundsBonusSystemStates.EXPIRED_SPINNING
      ].includes(state),
      isAlwaysWithoutOpacity: true
    },
    {
      key: BONUS_DETAILS_KEYS.DATE,
      name: t('bonuses.details.completed'),
      value: f
        .getDateTime({
          date: updatedAt,
          fromUTC: true,
          format: 'dd.MM.yyyy HH:mm:ss'
        })
        ?.toFormat(DATE_FORMATS_TYPES.BONUSES_DATE_FORMAT),
      isDisplay: state === fundsBonusSystemStates.COMPLETED,
      isAlwaysWithoutOpacity: true
    },
    {
      key: BONUS_DETAILS_KEYS.DATE,
      name: t('bonuses.details.canceled'),
      value: f
        .getDateTime({
          date: updatedAt,
          fromUTC: true,
          format: 'dd.MM.yyyy HH:mm:ss'
        })
        ?.toFormat(DATE_FORMATS_TYPES.BONUSES_DATE_FORMAT),
      isDisplay: state === fundsBonusSystemStates.CANCELED_BY_PLAYER,
      isAlwaysWithoutOpacity: true
    }
  ]);
};

export const normalizeFundsBonusDetails = ({
  bonusData = {},
  userData,
  t,
  f,
  isShowServices,
  isShowMaxBonus,
  isShowBonusAmountText = true
}) => {
  const {
    state,
    acceptMode,
    outputBetTotal,
    outputMaxTotal,
    maxActivationTime = {},
    isCashback,
    bonusType,
    isBsBonus
  } = bonusData;
  const { activeWallet = {}, wallets = [], feWallets } = userData;
  const { deposit: userBalance = 0 } = activeWallet;

  const isCashbackBonus = isCashback ? 'cashback' : 'funds';
  const type = bonusType ? 'bonussystem' : isCashbackBonus;

  const isCanAccept = acceptModeType.ACCEPT.includes(acceptMode);
  const isPotential = state === fundsStates.BONUS_POTENCIAL;
  const isWagerAvailable = acceptModeType.WAGER.includes(acceptMode);
  const isBonusSystemProposed = state === fundsBonusSystemStates.PROPOSED;
  const isBonusSystemPotential = state === fundsBonusSystemStates.POTENTIAL;
  const isBonusSpinning = state === fundsBonusSystemStates.SPINNING;
  const isShowWagerButton =
    state === fundsBonusSystemStates.WAGERING ||
    (state === fundsStates.BONUS_WAGERING && !isCashback && outputMaxTotal > 0);

  const isNoWallet = feWallets
    ? !feWallets.length
    : wallets.length === 0 &&
      userBalance <= 0 &&
      !isWagerAvailable &&
      !isCanAccept;

  return {
    ...bonusData,
    bonusImageType: type,
    isShowWagerButton,
    isActivation:
      state === fundsStates.PROPOSED_ACCEPT_REQUEST_BY_GAMER.isCanAccept,
    isPotential,
    isWagerAvailable,
    isBonusSystemProposed,
    isBonusSystemPotential,
    isCanAccept,
    isShowButton:
      isCanAccept ||
      isPotential ||
      isWagerAvailable ||
      isBonusSystemProposed ||
      isBonusSystemPotential ||
      isShowWagerButton ||
      isBonusSpinning,
    isNoWallet,
    isBonusSpinning,
    buttonType: (() => {
      if (isPotential || isNoWallet || isBonusSystemPotential) {
        return 'deposit';
      }
      if (isWagerAvailable) {
        return outputBetTotal === 0 ? 'start' : 'resume';
      }
      if (isCanAccept) {
        return 'accept';
      }
      if (isBonusSystemProposed) {
        return 'start';
      }
      if (isShowWagerButton) {
        return 'wager';
      }
      if (isBonusSpinning) {
        return 'play';
      }
      return '';
    })(),
    isWagerEnabled:
      outputMaxTotal > 0 &&
      [
        fundsStates.BONUS_WAGERING,
        fundsStates.BONUS_PROPOSED,
        fundsStates.BONUS_INCOME_NOT_ACHIEVED,
        fundsStates.BONUS_OUTPUT_NOT_ACHIEVED,
        fundsStates.BONUS_WASNOT_ACTIVATED,
        fundsBonusSystemStates.WAGERING,
        fundsBonusSystemStates.COMPLETED,
        ...(bonusType === PWS_BONUS_TYPE
          ? []
          : [
              fundsBonusSystemStates.CANCELED_BY_PLAYER,
              fundsBonusSystemStates.EXPIRED_WAGERING_PERIOD,
              fundsBonusSystemStates.EXPIRED_PROPOSED
            ])
      ].includes(state),
    progressBarStatus: getProgressBarStatus({ state, outputBetTotal }),
    ...(isBsBonus && { isBsBonus }),
    isCountdownTimerEnabled:
      state === fundsStates.BONUS_POTENCIAL ||
      state === fundsStates.BONUS_WAGERING ||
      (state === fundsStates.BONUS_PROPOSED && outputMaxTotal > 0) ||
      (state === fundsStates.BONUS_PROPOSED && isCashback) ||
      (state === fundsStates.BONUS_WAGERING && isCashback) ||
      (state === fundsStates.BONUS_ACTVATED && isCashback) ||
      (!!isBsBonus &&
        [
          fundsBonusSystemStates.POTENTIAL,
          fundsBonusSystemStates.PROPOSED,
          fundsBonusSystemStates.WAGERING,
          fundsBonusSystemStates.SPINNING
        ].includes(state)),
    countdownTimerTitle: getTimerTitle({
      state,
      isCashback,
      outputMaxTotal,
      t
    }),
    expireTime: {
      ...maxActivationTime,
      ms: maxActivationTime?.sec * 1000
    },
    bonusDetailsList: getBonusDetailsList({
      bonusData,
      f,
      t,
      isShowServices,
      isShowMaxBonus,
      isShowBonusAmountText
    }),
    ...(!bonusType && {
      imageColorAccent:
        ACCENT_COLOR_TYPE_BY_BONUS[BONUSES_TYPES_FOR_IMAGES.CRM_FUNDS_BONUS]
    })
  };
};
